import React from "react"
import PropTypes from "prop-types"
import Link from "../UI/Link/Link"
import Button from "../UI/Button/Button"
import Image from "../UI/Image/Image"
import * as styles from "./TwoSectionLayout-tw-styles"
import RichTextModel from "../../components/RichTextModel/RichTextModel"
import { get } from "../../helpers/utils"
import useImage from "../../hooks/useImage"
import Typography from "../UI/Typography/Typography"
import SocialLinks from "../SocialLinks/SocialLinks"
const TwoSectionLayout = props => {
  const {
    sectionTitle,
    middleContent,
    imagePositionLeft,
    variant,
    imagePositionRight,
    imagePropsRight,
    imagePropsLeft,
    descriptionCollection,
    contentCollection,
    isSVG = false,
    svgImageLeft = {},
    svgImageRight = {},
    button,
    richTextData = null,
    richTextDataSecondary = null,
    buttonSecondary = {},
  } = props
  const content = get(descriptionCollection, "items", [])

  const style = styles[variant] || styles.defaultStyle

  const renderRichTextSecondary = (richTextDataSecondary, buttonSecondary) => {
    return (
      <div>
        {richTextDataSecondary && <RichTextModel {...richTextDataSecondary} />}
        {buttonSecondary && (
          <Link url={buttonSecondary?.url}>
            <Button text={buttonSecondary?.text}></Button>
          </Link>
        )}
      </div>
    )
  }
  let imageProps = {}
  if (imagePropsLeft) {
    imageProps = imagePropsLeft
  } else {
    imageProps = imagePropsRight
  }
  const { altText, foregroundImg } = useImage(imageProps)
  const renderImage = (isSVG = false, svgImage = {}) => {
    return isSVG ? (
      <div>{svgImage}</div>
    ) : (
      <div className={style?.bigImage}>
        <Image
          alt={altText}
          contentfulImage={foregroundImg}
          className={style?.bigImg}
        />
        {foregroundImg?.description && (
          <Typography content={foregroundImg?.description} />
        )}
      </div>
    )
  }

  const renderSection = (data, index) => {
    let name = data?.__typename
    switch (name) {
      case "TextContent": {
        return (
          <div className={style?.titleOne} key={index}>
            {data?.title && (
              <Typography content={data?.title} className={style?.heading} />
            )}

            {data?.shortDescription && (
              <Typography
                content={data?.shortDescription}
                className={style?.paraDes}
                allow_br_tag={true}
              />
            )}
            {data?.content && (
              <Typography
                content={data?.content}
                className={style?.paraDes}
                allow_br_tag={true}
              />
            )}
          </div>
        )
      }
      case "SocialLinks": {
        return (
          <div key={index}>
            <SocialLinks linkCollection={data?.linkCollection} />
          </div>
        )
      }
      case "Link": {
        return (
          <div className={style?.LinkTwo} key={index}>
            <Link {...data} />
          </div>
        )
      }
      default:
        break
    }
  }

  return (
    <>
      <div className={style?.contentWrapperBgColor}>
        <div className={style?.contentWrapper}>
          {sectionTitle && (
            <h2 className={style?.greenh2Heading}>{sectionTitle}</h2>
          )}
          {middleContent && (
            <p>
              <Typography
                className={style?.description}
                allow_br_tag={true}
                content={middleContent}
              />{" "}
            </p>
          )}

          <div className={style?.flexContent}>
            {imagePositionLeft && renderImage(isSVG, svgImageLeft)}
            <div className={style?.rightContent}>
              {content.map((item, index) => {
                return (
                  <div className={style?.contentText} key={index}>
                    <p className={style?.heading}>{item?.title}</p>
                    {item?.shortDescription && (
                      <Typography
                        content={item?.shortDescription}
                        className={style?.description}
                      />
                    )}
                  </div>
                )
              })}
              {richTextData && <RichTextModel {...richTextData} />}
              {button && (
                <Link url={button?.url}>
                  <Button text={button?.text}></Button>
                </Link>
              )}
            </div>
            {richTextDataSecondary &&
              renderRichTextSecondary(richTextDataSecondary, buttonSecondary)}

            {contentCollection.items.length > 0 && (
              <div className={style?.leftContentWrapper}>
                {imagePositionRight && renderImage(isSVG, svgImageRight)}
                <div className={style?.descWrapper}>
                  {contentCollection.items.map((data, index) => {
                    return renderSection(data, index)
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

TwoSectionLayout.propTypes = {
  data: PropTypes.array,
  style: PropTypes.object,
  content: PropTypes.array,
  imagePropsRight: PropTypes.object,
  imagePositionRight: PropTypes.bool,
  imagePropsLeft: PropTypes.object,
  imagePositionLeft: PropTypes.bool,
  isSVG: PropTypes.bool,
  svgImageRight: PropTypes.object,
  svgImageLeft: PropTypes.object,
  button: PropTypes.object,
  richTextData: PropTypes.object,
  richTextDataSecondary: PropTypes.object,
  buttonSecondary: PropTypes.object,
  sectionTitle: PropTypes.string,
  middleContent: PropTypes.string,
  descriptionCollection: PropTypes.object,
  variant: PropTypes.string,
  contentCollection: PropTypes.object,
}

export default TwoSectionLayout
